import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Blog } from '../../model/blog';
import { Store } from '@ngrx/store';
import { MatSnackBar } from '@angular/material/snack-bar';
import { addBlog, addBlogSuccess } from '../../action/blog.actions';

@Component({
  selector: 'app-blog-dialog',
  templateUrl: './blog-dialog.component.html',
  styleUrl: './blog-dialog.component.scss'
})
export class BlogDialogComponent {
 blogForm:FormGroup
 editBlogForm:FormGroup
 editBlog:boolean=false;
  imageUrl: string = '';
  selectedImage: string | ArrayBuffer | null = null;
  currentBlog: any;
  blogSaved = false;
  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],  // Text formatting
      [{ 'font': [] }, { 'size': [] }],           // Font and size
      [{ 'align': [] }],                          // Text alignment (includes justify)
      ['link', 'image', 'video'],                 // Media (link, image, video)
      [{ 'list': 'ordered' }, { 'list': 'bullet' }], // Lists
      [{ 'indent': '-1' }, { 'indent': '+1' }],   // Indentation
      ['blockquote'],                             // Blockquote
      ['code-block'],                             // Code block
      [{ 'color': [] }, { 'background': [] }],    // Text and background colors
      ['clean'],                                  // Clear formatting
      ['undo', 'redo'],                           // Undo and Redo actions
      [{ 'direction': 'rtl' }],                   // Text direction (RTL)
      ['emoji'],                                  // Emoji picker (if added via plugin)
    ]
  };

  languageSelected: string = 'english';

  blog: Blog | undefined;
  constructor(private fb:FormBuilder,private store:Store,private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<BlogDialogComponent> ,@Inject(MAT_DIALOG_DATA) public data: { blog: Blog }){
    this.blogForm = this.fb.group({
      titleen: ['', Validators.required],
      titlees: ['', Validators.required],
      titlept: ['', Validators.required],
      titlefr: ['', Validators.required],

      imageen: [null],
      imagefr: [null],
      imagees: [null],
      imagept: [null],
    // subtitle: [null],

      //seotitile
      seotitleen: [null],
      seotitlefr:[null],
      seotitlees:[null],
      seotitlept:[null],

      //seodesc formcontrol
      seodescriptionen: [null],
      seodescriptionfr: [null],
      seodescriptiones: [null],
      seodescriptionpt: [null],

      //seokeyword formcontrol
      seokeyworden: [null],
      seokeywordfr: [null],
      seokeywordes: [null],
      seokeywordpt: [null],

      //scontent for language
      contenten: ['', Validators.required],
      contentfr: ['', Validators.required],
      contentes: ['', Validators.required],
      contentpt: ['', Validators.required],

      iden:[''],
      statusen:['0'],
      routing_titleen:[''],
      cta_button_one_enableden:[false],
      cta_button_two_enableden:[false],
      cta_button_one_texten:[],
      cta_button_one_linken:[],
      cta_button_two_texten:[],
      cta_button_two_linken:[],
      togglecontrolen:[false],
      cta_button_one_source_nameen:[""],
      togglecontrol1en:[false],
      cta_button_two_source_nameen:[""],


//french
      idfr:[''],
      statusfr:['0'],
      routing_titlefr:[''],
      cta_button_one_enabledfr:[false],
      cta_button_two_enabledfr:[false],
      cta_button_one_textfr:[],
      cta_button_one_linkfr:[],
      cta_button_two_textfr:[],
      cta_button_two_linkfr:[],
      togglecontrolfr:[false],
      cta_button_one_source_namefr:[""],
      togglecontrol1fr:[false],
      cta_button_two_source_namefr:[""],


      //spanish
      ides:[''],
      statuses:['0'],
      routing_titlees:[''],
      cta_button_one_enabledes:[false],
      cta_button_two_enabledes:[false],
      cta_button_one_textes:[],
      cta_button_one_linkes:[],
      cta_button_two_textes:[],
      cta_button_two_linkes:[],
      togglecontroles:[false],
      cta_button_one_source_namees:[""],
      togglecontrol1es:[false],
      cta_button_two_source_namees:[""],


      idpt:[''],
      statuspt:['0'],
      routing_titlept:[''],
      cta_button_one_enabledpt:[false],
      cta_button_two_enabledpt:[false],
      cta_button_one_textpt:[],
      cta_button_one_linkpt:[],
      cta_button_two_textpt:[],
      cta_button_two_linkpt:[],
      togglecontrolpt:[false],
      cta_button_one_source_namept:[""],
      togglecontrol1pt:[false],
      cta_button_two_source_namept:[""]


    });
    this.editBlogForm = this.fb.group({
      title: ['', Validators.required],
      content: ['', Validators.required],
      image: [null],
      // subtitle: [null],
      seotitle: [null],
      seodescription: [null],
      seokeyword: [null],
      id:[''],
      status:['0'],
      routing_title:[''],
      cta_button_one_enabled:[false],
      cta_button_two_enabled:[false],
      cta_button_one_text:[],
      cta_button_one_link:[],
      cta_button_two_text:[],
      cta_button_two_link:[],
      togglecontrol:[false],
      cta_button_one_source_name:[""],
      togglecontrol1:[false],
      cta_button_two_source_name:[""],
      languagestatus:[]

    });
    if (data.blog) {
      this.blog = data.blog;
      this.editBlog=true;
      this.editBlogForm.patchValue(this.blog);
      this.imageBase64Url=this.blog.imageUrl;
      // this.blogForm.get('image').setValue(this.blog.imageUrl)

      // console.log(this.blogForm.get('image').value,'skdufsjkdfjkajfd')
    }
  }

  setLanguage(lang: string) {
    this.languageSelected = lang;
  }
  onEditSubmit() {
    console.log(this.editBlogForm,'this.blogForm')
    // if (this.blogForm.valid) {
      const blog: Blog = {
        id:this.editBlogForm.value.id,
        title: this.editBlogForm.value.title,
        content: this.editBlogForm.value.content,
        imageUrl: this.imageBase64Url,
        subtitle: this.editBlogForm.value.subtitle,
        createdAt: new Date(),
        status:'0',
        seotitle: this.editBlogForm.value.seotitle,
        seodescription: this.editBlogForm.value.seodescription,
        seokeyword:this.editBlogForm.value.seokeyword,
        routing_title:this.editBlogForm.value.routing_title,
        cta_button_one_enabled:this.editBlogForm.value.cta_button_one_enabled,
        cta_button_two_enabled:this.editBlogForm.value.cta_button_two_enabled,
        cta_button_one_text:this.editBlogForm.value.cta_button_one_text,
        cta_button_one_link:this.editBlogForm.value.cta_button_one_link,
        cta_button_two_text:this.editBlogForm.value.cta_button_two_text,
        cta_button_two_link:this.editBlogForm.value.cta_button_two_link,
        togglecontrol:this.editBlogForm.value.togglecontrol,
        cta_button_one_source_name:this.editBlogForm.value.cta_button_one_source_name,
        togglecontrol1:this.editBlogForm.value.togglecontrol1,
        cta_button_two_source_name:this.editBlogForm.value.cta_button_two_source_name,
        languagestatus:this.editBlogForm.value.languagestatus,
      };

      this.store.dispatch(addBlog({ blog:blog }));
      this.snackBar.open('Blog added successfully!', 'Close', { duration: 3000 });
      this.dialogRef.close(); // Close the dialog after saving
    // } else {
    //   this.snackBar.open('Please fill out all fields', 'Close', { duration: 3000 });
    // }
  }
  onSubmit() {
    console.log(this.blogForm,'this.blogForm')
    // if (this.blogForm.valid) {
      this.newBlog(this.blogForm.value.titleen,
      this.blogForm.value.seotitleen,
      this.blogForm.value.seodescriptionen,
      this.blogForm.value.seokeyworden,
      this.blogForm.value.contenten,
      this.blogForm.value.routing_titleen,
      this.blogForm.value.cta_button_one_enableden,
      this.blogForm.value.cta_button_two_enableden,
      this.blogForm.value.cta_button_one_texten,
      this.blogForm.value.cta_button_one_linken,
      this.blogForm.value.cta_button_two_texten,
      this.blogForm.value.cta_button_two_linken,
      this.blogForm.value. cta_button_one_source_nameen,
      this.blogForm.value.cta_button_two_source_nameen, 'en')


      this.newBlog(this.blogForm.value.titlefr,
        this.blogForm.value.seotitlefr,
        this.blogForm.value.seodescriptionfr,
        this.blogForm.value.seokeywordfr,
        this.blogForm.value.contentfr,
        this.blogForm.value.routing_titlefr,
        this.blogForm.value.cta_button_one_enabledfr,
        this.blogForm.value.cta_button_two_enabledfr,
        this.blogForm.value.cta_button_one_textfr,
        this.blogForm.value.cta_button_one_linkfr,
        this.blogForm.value.cta_button_two_textfr,
        this.blogForm.value.cta_button_two_linkfr,
        this.blogForm.value.cta_button_one_source_namefr,
        this.blogForm.value.cta_button_two_source_namefr,'fr')

        this.newBlog(this.blogForm.value.titlees,
          this.blogForm.value.seotitlees,
          this.blogForm.value.seodescriptiones,
          this.blogForm.value.seokeywordes,
          this.blogForm.value.contentes,
          this.blogForm.value.routing_titlees,
          this.blogForm.value.cta_button_one_enabledes,
          this.blogForm.value.cta_button_two_enabledes,
          this.blogForm.value.cta_button_one_textes,
          this.blogForm.value.cta_button_one_linkes,
          this.blogForm.value.cta_button_two_textes,
          this.blogForm.value.cta_button_two_linkes,
          this.blogForm.value.cta_button_one_source_namees,
          this.blogForm.value.cta_button_two_source_namees,'es')


        this.newBlog(this.blogForm.value.titlept,
          this.blogForm.value.seotitlept,
          this.blogForm.value.seodescriptionpt,
          this.blogForm.value.seokeywordpt,
          this.blogForm.value.contentpt,
          this.blogForm.value.routing_titlept,
          this.blogForm.value.cta_button_one_enabledpt,
          this.blogForm.value.cta_button_two_enabledpt,
          this.blogForm.value.cta_button_one_textpt,
          this.blogForm.value.cta_button_one_linkpt,
          this.blogForm.value.cta_button_two_textpt,
          this.blogForm.value.cta_button_two_linkpt,
          this.blogForm.value.cta_button_one_source_namept,
          this.blogForm.value.cta_button_two_source_namept,'pt')

            }
  imageBase64Url: string | null = null;

  onImageChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files && input.files.length > 0) {
      const file = input.files[0];

      const reader = new FileReader();
      reader.onload = () => {
        this.imageBase64Url = reader.result as string;
        console.log('Base64 URL:', this.imageBase64Url);
      };
      reader.onerror = (error) => {
        console.error('Error converting file to Base64:', error);
      };
      reader.readAsDataURL(file);
    }
  }
  toggleAction() {
    this.blogForm.get('togglecontrol')?.setValue(!this.blogForm.get('togglecontrol')?.value);
  }
  toggleAction1() {
    this.blogForm.get('togglecontrol1')?.setValue(!this.blogForm.get('togglecontrol1')?.value);
  }
  editToggleAction() {
    this.editBlogForm.get('togglecontrol')?.setValue(!this.editBlogForm.get('togglecontrol')?.value);
  }
  editToggleAction1() {
    this.editBlogForm.get('togglecontrol1')?.setValue(!this.editBlogForm.get('togglecontrol1')?.value);
  }

  newBlog(title:any,
    seotitle:any,
    seodescription:any,
    keyword:any,
    content:any,
    routing_title:any,
    cta_button_one_enabled:any,
    cta_button_two_enabled:any,
    cta_button_one_text:any,
    cta_button_one_link:any,
    cta_button_two_text:any,
    cta_button_two_link:any,
    cta_button_one_source_name:any,
    cta_button_two_source_name:any,
    languagestatus:any,){
    const blog: Blog = {

      id:this.blogForm.value.id,
      title:title,
      // title: this.blogForm.value.titleen,

      imageUrl: this.imageBase64Url,
      subtitle: this.blogForm.value.subtitle,
      createdAt: new Date(),
      status:'0',
      seotitle: seotitle,
      seodescription: seodescription,
      seokeyword:keyword,
      content: content,
      routing_title:routing_title,
      cta_button_one_enabled:cta_button_one_enabled,
      cta_button_two_enabled:cta_button_two_enabled,
      cta_button_one_text:cta_button_one_text,
      cta_button_one_link:cta_button_one_link,
      cta_button_two_text:cta_button_two_text,
      cta_button_two_link:cta_button_two_link,
      togglecontrol:this.blogForm.value.togglecontrol,
      cta_button_one_source_name:cta_button_one_source_name,
      togglecontrol1:this.blogForm.value.togglecontrol1,
      cta_button_two_source_name:cta_button_two_source_name,

      languagestatus:languagestatus,
    };

    this.store.dispatch(addBlog({ blog:blog }));
    this.snackBar.open('Blog added successfully!', 'Close', { duration: 3000 });
    this.dialogRef.close(); // Close the dialog after saving
  // } else {
  //   this.snackBar.open('Please fill out all fields', 'Close', { duration: 3000 });
  // }
  }
}
